module.exports = __webpack_public_path__ + "img/gonggao.65950a01.png";